import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { Component, Input, OnInit } from '@angular/core';
import { Pdf } from '@shared/helpers/pdf-wrapper.helper';
import { ReportService } from '../services/report.service';
import { PageTableDef } from '@shared/interfaces/table.interface';
import { ReportRequest } from '../interfaces/report-response.interface';
import { ReportRecipeResponse } from '@shared/interfaces/report.interface';
import { PatientReportComponent } from '../patient-report/patient-report.component';
import { RECIPES_V2 } from '@clinical/medicines/constants/recipe.constant';

@Component({
  selector: 'app-report-modal',
  templateUrl: './report-modal-v2.component.html',
  styleUrls: ['./report-modal-v2.component.scss'],
})
export class ReportModalComponentV2 implements OnInit {
  @Input() data;
  @Input() index;
  @Input() hideButtons;
  @Input() pageTable: PageTableDef;

  pdfDecode: string;
  currentGroup: string;
  isLoading = true;
  titles: string[] = [];

  constructor(
    private pdf: Pdf,
    public router: Router,
    private reportService: ReportService,
    private modalController: ModalController,
  ) { }

  ngOnInit(): void {
    if (this.data?.scope && this.pageTable)
      this.titles.push(RECIPES_V2[this.data.scope].section);

    this.viewPdfV2(this.data);
  }

  viewPdf(index, content) {
    if (!content.attachments) return;

    // 🔹 Ordenar los adjuntos en el orden deseado
    const orderedAttachments = [...this.data.attachments].sort((a, b) => {
      const order = { laboratorio: 0, imagenes: 1, procedimientos: 2 };
      return order[a.category] - order[b.category];
    });

    // 🔹 Asegurar que usamos el orden correcto al acceder
    const { bucket, path, key } = orderedAttachments[index];

    // 🔹 Determinar el grupo actual según el contexto
    if (content !== 'attachments') {
      this.currentGroup = this.data[this.pageTable.array][0].group;
    } else {
      this.currentGroup = this.data.content[0].group;
    }

    // 🔹 Cargar y visualizar el PDF
    this.reportService.getPdf(bucket, path, key).subscribe((res) => {
      const pdfEncode = `data:application/pdf;base64,${res}`;
      this.pdf.visualize(pdfEncode);
      this.isLoading = false;
    });
  }

  viewPdfV2(data: ReportRecipeResponse) {
    if (!data.attachments) return;
    this.currentGroup = RECIPES_V2[data.scope].section;
    const params: ReportRequest = {
      provider: 'aws',
      path: data.attachments[0],
    }

    this.reportService.getPdfV2(params).subscribe((res) => {
      const pdfEncode = `data:application/pdf;base64,${res.base64}`;
      this.pdf.visualize(pdfEncode);
      this.isLoading = false;
    });
  }

  async pdfPreview(group: any) {
    this.isLoading = true;
    this.viewPdfV2(this.data);
  }

  async viewPatient() {
    this.dismiss();
    delete this.pageTable.title;
    const modal = await this.modalController.create({
      component: PatientReportComponent,
      cssClass: 'cmodal-xl',
      componentProps: { data: this.data, pageTable: this.pageTable },
    });
    await modal.present();
  }

  routeCreateNew() {
    this.router.navigate([`${this.pageTable.router}`]);
    this.modalController.dismiss();
  }

  dismiss() {
    this.modalController.dismiss();
  }
}
